const HamburgerMenuIcon = ({ isOpen, isWhite }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" className={`hamburger-icon ${isOpen ? " open" : ""} `}>
    <rect className={`bar bar1  ${isWhite ? " white" : ""}`} x="3" y="5" width="18" height="2" rx="1" />
    <rect className={`bar bar2 ${isWhite ? " white" : ""}`} x="3" y="11" width="18" height="2" rx="1" />
    <rect className={`bar bar3 ${isWhite ? " white" : ""}`} x="3" y="17" width="18" height="2" rx="1" />
  </svg>
);

export default HamburgerMenuIcon;
